
<template>
  <b-row>
    <b-col>
      <b-card 
        no-body 
        :class="{ open: visibleBody }" 
      >
        <b-card-header 
          style="background-color: #0080C9; color: white; font:45px; padding:15px; padding:1rem "
          header="Historial Clinico" 
          :class="{ collapsed: !visibleBody }"
          data-toggle="collapse" 
          @click="() => visibleBody = !visibleBody"  
        >
          <span class="lead collapse-title">
            <strong>Historial Derivaciones / Interconsultas</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse 
          v-model="visibleBody" 
          role="tabpanel"
        >
          <b-card-body style="padding: 5px">

            <div 
              v-if="isLoading" 
              class="mt-3 d-flex justify-content-center"
            >
              <b-spinner 
                style="width: 3rem; height: 3rem;" 
                variant="primary"
              /> 
            </div>

            <div v-if="!isLoading">
              <div class="d-flex justify-content-between">
                <h5 class="mt-1">Historial de Derivaciones</h5>
                <h6 class="text-right my-1 mx-1">Total: {{tableDe.totalRows}}</h6>
              </div>

              <b-table
                v-if="historialDerivaciones.length"
                id="table-img" 
                responsive bordered small 
                :items="historialDerivaciones" 
                :fields="fieldsTable" 
                :per-page="tableDe.perPage"
                :current-page="tableDe.page"
              >         
                <template #cell(acciones)="data">
                  <b-button 
                    variant="info" 
                    size="sm" 
                    style="cursor: pointer"
                    @click="onViewDerivacion(data.item.token)"
                  >
                    <font-awesome-icon icon="magnifying-glass" style="color: white"/>
                  </b-button>
                </template>
              </b-table>

              <DerivacionModalView/>

              <EmptyResults
                size="sm"
                v-if="!historialDerivaciones.length && !loadingDataDe"
              />

            </div>


            <div v-if="!isLoading">
              <div>
                <div class="d-flex justify-content-between">
                  <h5 class="mt-1">Historial de Interconsultas</h5>
                  <h6 class="text-right my-1 mx-1">Total: {{tableIn.totalRows}}</h6>
                </div>
              </div>
  
              <b-table
                v-if="historialInterconsultas.length"
                id="table-img" 
                responsive bordered small 
                :items="historialInterconsultas" 
                :fields="fieldsTable" 
                :per-page="tableIn.perPage"
                :current-page="tableIn.page"
              >         
                <template #cell(acciones)="data">
                  <b-button 
                    variant="info" 
                    size="sm" 
                    style="cursor: pointer"
                    @click="onViewInterconsulta(data.item.token)"
                  >
                    <font-awesome-icon icon="magnifying-glass" style="color: white"/>
                  </b-button>
                </template>
              </b-table>
  
              <EmptyResults
                size="sm"
                v-if="!historialInterconsultas.length && !loadingDataIn"
              />
              
              <InterconsultaModalView/>
            </div> 

          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>

    

  </b-row>
</template>

<script>
import { InterconsultaModalView, DerivacionModalView } from '@/views/derivaciones/components';
import { EmptyResults }         from '@/shared/components';
import { getItemByValueId }     from '@/shared/helpers';
import { interconsultaService } from '../../../derivaciones/services/interconsultaService';
import { derivacionesService }  from '../../../derivaciones/services';

export default {

  name: "HistorialDerivacionesInterconsultas",

  props: {
    idPaciente: String,
  },

  components: {
    InterconsultaModalView,
    DerivacionModalView,
    EmptyResults
  },

  created() {
    this.loadDataHistorial();
  },

  data() {
    return {
      visibleBody: false,

      // Derivaciones
      historialDerivaciones : [],
      loadingDataDe: false,

      tableDe:{
        perPage: 6,
        page: 1,
        totalRows: 0
      },



      // Interconsultas
      historialInterconsultas : [],
      loadingDataIn: false,

      tableIn:{
        perPage: 6,
        page: 1,
        totalRows: 0
      },

      fieldsTable: [
        { key: "fecha", label: "Fecha" },
        { key: "especialidad",     label: "especialidad" },
        
        {
          key: "acciones",
          label: "acciones",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],

      tipoAtencionOpts: [
        { value: '1', text: "Consulta Externa" },
        { value: '2', text: "Laboratorio" },
        { value: '3', text: "Imagen" },
        { value: '4', text: "Procedimientos Diagnósticos" },
        { value: '5', text: "Hospitalización" },
        { value: '6', text: "Emergencia" },
        { value: '7', text: "Tratamiento Integral Oncologico" }
      ],
    }
  },

  methods: {
    
    loadDataHistorial(){
      this.loadDerivaciones();
      this.loadInterconsultas();
    },


    async loadDerivaciones(){
      this.loadingDataDe = true;

      const params = {
        idPaciente : this.idPaciente
      };

      const responseSearch = await derivacionesService.getAll(params);

      if(!responseSearch) {
        this.loadingData = false;
        return
      }

      this.tableDe.totalRows = responseSearch.total;

      const mapperDerivaciones = responseSearch.derivaciones.map(item => {

        // const tipoAtencion = item.tipoAtencion;
        const tipoAtencion = getItemByValueId(this.tipoAtencionOpts, item.tipoAtencion)?.text;
        const especialidad = item.especialidad?.descripcion || '';

        const atencionEspecialidad = `${tipoAtencion} ${especialidad}`;

        return {
          
          id              : item.id,
          token           : item.token,
          fecha           : item.fechaDerivacion,
          especialidad    : atencionEspecialidad
        }
      });

      this.historialDerivaciones = mapperDerivaciones;
      this.loadingDataDe = false;

    },


    async loadInterconsultas(){

      this.loadingDataIn = true;

      const params = {
        paciente : this.idPaciente
      };

      const responseSearch = await interconsultaService.getAll(params);

      if(!responseSearch) {
        this.loadingData = false;
        return
      }

      this.tableIn.totalRows = responseSearch.total;
      const mapperInterconsultas = responseSearch.interconsultas.map(item => ({

        id              : item.id,
        token           : item.token,
        fecha           : item.fechaInterconsulta,
        especialidad    : item.especialidad?.descripcion,

      }));

      this.historialInterconsultas = mapperInterconsultas;
      this.loadingDataIn = false;
    },

    onViewDerivacion(tokenDerivacion){
      try{
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query, 
            view_derivacion: tokenDerivacion
          }
        });
      }catch(error){
        console.log("este es el rror", error)
      }
    },

    onViewInterconsulta(tokenInterconsulta){
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query, 
            view_interconsulta: tokenInterconsulta
          }
        });
      } catch (error) { console.log("este es el rror", error) }
    }
  },

  computed: {
    
    isLoading(){
      return this.loadingDataDe || this.loadingDataIn;
    }
  }
}
</script>